<template>
  <div class="container-fluid">
    <div class="row mb-3">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <h4>Add new Translation</h4>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 form-group">
                <label class="d-block text-muted">Translation key</label>
                <input class="form-control" v-model="key" />
              </div>
              <div class="col-lg-6 form-group">
                <label class="d-block text-muted">Translation in EN</label>
                <input class="form-control" v-model="en" />
              </div>
               <div class="col-lg-6 form-group">
                <label class="d-block text-muted">Translation in EL</label>
                <input class="form-control" v-model="el" />
              </div>
            </div>
            <div class="row">
              <div class="col d-flex">
                <div class="ml-auto">
                  <button type="button" class="btn btn-outline-primary" @click="addTranslation">Add</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-sm-12 text-center">
        <h2>{{translations.length}} Translations found!</h2>
      </div>
    </div>
    <div class="row">
      <div class="offset-lg-6  col-lg-6 form-group">
        <input class="form-control" type="text" v-model="search" />
      </div>
    </div>
    <div v-if="filteredTranslations.length" class="row mb-3">
      <div v-for="item in filteredTranslations" :key="item._id" class="col-lg-12">
        <div class="card">
          <div class="card-header text-center">
            <h4 class="mb-0">{{item.key}}</h4>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-lg-6 form-group mb-0">
                <label class="d-block text-muted">Translation in EN</label>
                <input type="text" class="form-control" v-model="item.translation.en" />
                <!-- {{item.translation.en}} -->
              </div>
               <div class="col-lg-6 form-group mb-0">
                <label class="d-block text-muted">Translation in EL</label>
                <input type="text" class="form-control" v-model="item.translation.el" />
                <!-- {{item.translation.en}} -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="filteredTranslations.length" class="row">
      <div class="col d-flex">
        <div class="ml-auto">
          <button type="button" class="btn btn-outline-primary" @click="saveChanges">Save changes</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      translations: [],
      key: null,
      en: null,
      el: null,
      search: ''
    };
  },
  computed: {
    filteredTranslations() {
      if (this.search === '') return this.translations;
      // eslint-disable-next-line max-len
      return this.translations.filter((item) => item.key.toLowerCase().includes(this.search.toLowerCase()) || item.translation.en.toLowerCase().includes(this.search.toLowerCase()) || item.translation.el.toLowerCase().includes(this.search.toLowerCase()));
    }
  },
  async created() {
    await this.loadTranslations();
  },
  methods: {
    async loadTranslations() {
      const response = await axios.get('http://localhost:4000/translations');
      this.translations = response.data;
    },
    async addTranslation() {
      const translation = {
        key: this.key,
        translation: {
          en: this.en,
          el: this.el
        }
      };
      await axios.post('http://localhost:4000/translations/add', translation);
      await this.loadTranslations();
      this.key = '';
      this.en = '';
      this.el = '';
    },
    async saveChanges() {
      const response = await axios.post('http://localhost:4000/translations/update', this.translations);
      console.log(response);
    }
  }
};
</script>
